import React from 'react';
import { formatDate } from 'utils/dateFormater';
interface AuditType {
    version: any;
    handleTabSwitch: any;
}

const ViewHistoryRow: React.FC<AuditType> = ({ version, handleTabSwitch }) => {
  return (
    <>
      <div className='view-history-body-frame-row'>
        <div className='view-history-body-frame-row-date'>
          <div className='view-history-body-frame-row-date-text'>{formatDate(version.date)}</div>
        </div>
        <div className='view-history-body-frame-row-date'>
          <div className='view-history-body-frame-row-date-texts'>
            <div>{version.allTotal}</div>
          </div>
        </div>
        <div className='view-history-body-frame-row-date'>
          <div className='view-history-body-frame-row-date-texts'>
            <div>{version.newTotal}</div>
          </div>
        </div>
        <div className='view-history-body-frame-row-date'>
          <div className='view-history-body-frame-row-date-texts-underline' onClick={() => handleTabSwitch('Results')}>
            <div>View</div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewHistoryRow;
